var exports = {
  "wx": "x620889e6--2575cb--header",
  "Zp": "x620889e6--2575cb--layout",
  "Ex": "x620889e6--2575cb--header--fixed",
  "C$": "x620889e6--2575cb--nav",
  "vR": "x620889e6--2575cb--tabs",
  "ne": "x620889e6--2575cb--controls",
};

module.exports = exports;
